module.exports = __webpack_public_path__ + "img/zone01-amsterdam.128adcef.png";